import { Box } from "grommet";
import { memo, useCallback, useEffect, useState } from "react";

const ButtonGroup = ({ value = [], onChange, defaultValue }) => {

    const [toggledItems, setToggledItems] = useState(Array(value.length).fill(false, 0));

    const handleClick = useCallback((index) => {
        const newState = toggledItems.map((v, i) => i === index ? !v : v);
        setToggledItems(newState);
        const values = value.map((v, index) => ({ value: v.value, selected: newState[index] }));
        onChange({ target: { value: values }});
    }, [toggledItems, onChange])

    useEffect(() => {
        const newState = defaultValue.map(defVal => defVal.selected);

        console.log(newState);
        
        setToggledItems(newState);
    }, [defaultValue])

    return (
        <Box direction="row" gap="xxsmall">
            {value.map((item, index) => (
                <ButtonOption 
                    item={item} 
                    onClick={() => handleClick(index)} 
                    showBorder={toggledItems[index]}
                />
            ))}
        </Box>
    )
}

export default memo(ButtonGroup);

const ButtonOption = ({ item, onClick, showBorder }) => {

    return (
        <Box 
            pad={'small'} 
            round="small" 
            onClick={onClick} 
            focusIndicator={false} 
            hoverIndicator={true} 
            border={showBorder ? { size: '1px', style: 'solid', color: 'brand' } : {}}
        >
            {item.icon}
        </Box>
    )
}